import styles from "./TextToSpeechHeroSection.module.css";
import { FaBolt, FaMicrophone, FaGlobe, FaCode } from "react-icons/fa";
// import micImg from "../../assets/mic.png";
import micImg from "../../../Images/4plxes0z.png"
const TextToSpeechHeroSection = () => {
    return (
        <section className={styles.wrapper}>
            <div className={styles.container}>
                {/* Left Content */}
                <div className={styles.left}>
                    <span className={styles.badge}>AI-Powered Text-to-Speech</span>

                    <h1 className={styles.heading}>
                        Transform Text with <br />
                        <span>Intelligent Voice</span>
                    </h1>

                    <p className={styles.description}>
                        Studio-quality speech synthesis with emotional intelligence.
                        Sub-100ms latency. 14 languages with seamless Indic code-mixing in
                        native scripts.
                    </p>

                    <div className={styles.buttons}>
                        <button className={styles.primaryBtn}>Start Free Trial</button>
                        <button className={styles.secondaryBtn}>Try It Live</button>
                    </div>
                </div>

                {/* Right Image */}
                <div className={styles.right}>
                    <img src={micImg} alt="Microphone" />
                </div>
            </div>

            {/* Feature Cards */}
            <div className={styles.features}>
                <div className={styles.card}>
                    <FaBolt />
                    <h3>&lt; 100ms</h3>
                    <p>Latency (TTFB)</p>
                </div>

                <div className={styles.card}>
                    <FaMicrophone />
                    <h3>15+</h3>
                    <p>Emotional Tones</p>
                </div>

                <div className={styles.card}>
                    <FaGlobe />
                    <h3>12+</h3>
                    <p>Languages</p>
                </div>

                <div className={styles.card}>
                    <FaCode />
                    <h3>Native</h3>
                    <p>Code Mixing</p>
                </div>
            </div>
        </section>
    );
};

export default TextToSpeechHeroSection;
